import { useImmer } from "use-immer";
import { useRef, useState, useEffect, useContext } from "react";
import SimpleReactValidator from "simple-react-validator";
import { useSyncHistoryDetailsQueries } from "./useSyncHistoryDetailsQueries";
import { useParams, useSearchParams } from "react-router-dom";

export const useSyncHistoryDetails = ({ date, syncID }) => {
  const [state, setState] = useImmer({
    isLoading: true,
    dataList: {},
    filters: {},
    remarks: "",
    isOpenMoreModal: false,
  });

  const { syncDetails } = useSyncHistoryDetailsQueries({
    date,
    syncID: syncID,
  });

  // useEffect(() => {
  //   // getUnits();
  //   if (listQuery?.data) {
  //     setState((draft) => {
  //       draft.dataList = listQuery?.data || [];
  //       draft.isLoading = false;
  //     });
  //   }
  // }, [syncDetails?.data]);

  return {
    state,
    syncDetails,
  };
};
